export const TOGGLE_TIME_TO_PARK_CONTAINER = 'TOGGLE_TIME_TO_PARK_CONTAINER'

export function displayTimeToParkContainerReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_TIME_TO_PARK_CONTAINER:
            return action.payload
        default: return state
    }
}